import { ReduxAction } from '../../enums/const-enums';

export interface NotificationState {
  type: string;
  header: string;
  body: string;
}

const initialState: NotificationState = {
  type: '',
  header: '',
  body: '',
};

export interface NotificationAction {
  type: ReduxAction;
  payload: NotificationState;
}

export function notificationReducer(
  state: NotificationState = initialState,
  action: NotificationAction,
): NotificationState {
  switch (action.type) {
    case ReduxAction.NOTIFICATION_CLEAR:
      state.type = '';
      state.header = '';
      state.body = '';
      break;
    case ReduxAction.NOTIFICATION_SHOW:
      state.type = action.payload.type;
      state.header = action.payload.header;
      state.body = action.payload.body;
      break;
  }
  return state;
}
